<mat-card>{{'changePassword' | translate}}</mat-card>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'userName' | translate}}</mat-label>
            <input matInput [(ngModel)]="userName" readonly>
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'currentPassword' | translate}}</mat-label>
            <input matInput type="password" name="currpass" [(ngModel)]="currentPassword" required #currPassword="ngModel">
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'newPassword' | translate}}</mat-label>
            <input matInput type="password" name="newpass" [(ngModel)]="newPassword" required #new_Password="ngModel">
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'confirmNewPassword' | translate}}</mat-label>
            <input matInput type="password" name="confpass" autocomplete="off" [(ngModel)]="confirmNewPassword" required #confNewpassword="ngModel">
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="4" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>

        <button mat-raised-button color="primary" (click)="submit()" 
        [disabled]="currPassword.invalid || new_Password.invalid || confNewpassword.invalid">
            <mat-icon>done</mat-icon>
            {{'submit' | translate}}</button>
    </mat-grid-tile>
  </mat-grid-list>

  <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
